import { useDeepAContextNodeName } from '@/pocs/chat/composables/context-node'
import { createChatTranscript } from '@/pocs/chat/export/transcript'
import type { DeepAChatContextNode, DeepAChatMessage } from '@/pocs/chat/types'

export function useDeepAChatTranscript() {
  const { t, locale } = useI18n()
  const getContextNodeName = useDeepAContextNodeName()

  return function buildTranscript(
    messages: DeepAChatMessage[],
    contextNodes: DeepAChatContextNode[],
  ) {
    return createChatTranscript({
      messages,
      contextFolders: contextNodes.map(getContextNodeName),
      exportedAt: new Date(),
      locale: locale.value,
      labels: {
        context: t('deepa_chat.export.context'),
        question: t('deepa_chat.export.question'),
        answer: t('deepa_chat.export.answer'),
        incompleteAnswer: t('deepa_chat.export.incomplete_answer'),
        generatedBy: t('deepa_chat.export.generated_by'),
      },
    })
  }
}
